import { mapLink } from '../DataTypes/linkMapper';
import logger from '3-foundation/Logging/logger';

export interface Props {
	content: {
		contentType: 'linkList';
		properties: {
			heading: string | null;
			headingLink: Umbraco.Link | Umbraco.Link[] | null;
			links: {
				items: {
					content: {
						properties: {
							link: Umbraco.Link[];
						};
					};
				}[];
			};
			linkUrls: Umbraco.Link[] | null;
		};
	};
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapLinkList = ({ content }: any): Content.LinkList => {
	try {
		if (!content) throw new Error('Invalid linkList content');

		const headingLink = Array.isArray(content.properties.headingLink) ? content.properties.headingLink[0] : content.properties.headingLink;
		const mappedLinks = content.properties.linkUrls?.map(mapLink).filter(Boolean) ?? [];

		const heading = content.properties.heading ?? null;
		const mappedHeadingLink = mapLink(headingLink ?? null);
		const linkListItems = mappedLinks.length > 0 ? mappedLinks : null;

		// Return null if all properties are null
		if (!heading && !mappedHeadingLink && !linkListItems) {
			return null;
		}

		return {
			documentType: 'linkList',
			content: {
				heading,
				headingLink: mappedHeadingLink,
				linkListItems,
			},
		};
	} catch (e) {
		logger.error('Could not map LinkList', e);
		throw new Error('Could not map LinkList', e);
	}
};
